import { render, staticRenderFns } from "./BusinessOpportunityClosed.vue?vue&type=template&id=391c1b1d&"
import script from "./BusinessOpportunityClosed.vue?vue&type=script&lang=js&"
export * from "./BusinessOpportunityClosed.vue?vue&type=script&lang=js&"
import style0 from "./BusinessOpportunityClosed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports